import _ from 'lodash'
import axios from 'axios';
import{getUserToken} from '../utils/cookieService';
// import cookie from 'js-cookie'

const getJwt = () => {
  const authToken = getUserToken();

  if (!authToken) {
    return null
  }

  return authToken
}
const getCommontHeaders = () => {
    const token = getJwt()
    const authoriztion = token ? { authorization: `${token}` } : {}
    return {
      ...authoriztion,
    }
  }

const ax = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 60000,
})

export const get = (
  url,
  { headers = {}, params = {}, otherConfigs = {} } = {}
) =>
  ax.get(url, {
    headers: {
      ...getCommontHeaders(),
      ...headers,
    },
    params: {
      ...params,
    },
    ...otherConfigs,
  })

export const post = (
  url,
  body,
  { headers = {}, otherConfigs = {} } = {}
) => {
  return ax.post(url, body, {
    headers: {
      ...getCommontHeaders(),
      ...headers,
    },
    ...otherConfigs,
  })
}
export const put = (
  url,
  body,
  {headers = {}, otherConfigs = {} } = {}
) =>
  ax.put(url, body, {
    headers: {
      ...getCommontHeaders(),
      ...headers,
    },
    ...otherConfigs,
  })

export const removeNil = (obj) => _.omit(obj, _.isNil)